var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.33333H13.7592",
    stroke: "#64748B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5827 3.66667H6.41602C4.89723 3.66667 3.66602 4.89788 3.66602 6.41667V15.5833C3.66602 17.1021 4.89723 18.3333 6.41602 18.3333H15.5827C17.1015 18.3333 18.3327 17.1021 18.3327 15.5833V6.41667C18.3327 4.89788 17.1015 3.66667 15.5827 3.66667Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 13.75L7.33268 10.0833C7.75074 9.68106 8.22496 9.46928 8.70768 9.46928C9.19041 9.46928 9.66463 9.68106 10.0827 10.0833L14.666 14.6667",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.832 12.8333L13.7487 11.9167C14.1668 11.5144 14.641 11.3026 15.1237 11.3026C15.6064 11.3026 16.0806 11.5144 16.4987 11.9167L18.332 13.75",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.a4fca45616a4a4a3e0a278b68a02889b.svg";
export { ForwardRef as ReactComponent };